import React from 'react';
import './../../css/CardRedirection.css';
import {connect} from 'react-redux';
import {OnNoContactChannelLoad,OnNoContactChannelCancel} from './../../components/SiteCat/SiteCat';
import {unProcessableEntity} from './../../constants/merchantData';

class NoContactChannel extends React.Component{

  constructor() {
    super();

    this.state = {
      merchantName:"",
      authCode:""
    };
  }
  componentDidMount() {
    OnNoContactChannelLoad(this.state.merchantName);
    const cancelUrlData = this.props.lockedposts.cancelUrl ;
    this.setState({
      merchantName : this.props.lockedposts.merchant,
      authCode : this.props.lockedposts.authcode,
      cancelUrlData
    });
  }

  handleCancel = event => {
    OnNoContactChannelCancel(this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    unProcessableEntity(data);
  }
 
  render() {
    return(
      <React.Fragment>
        <div className="row">
          <div className="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
            <div className="no-contact-header">We'll need just a bit more information.</div>
    <div className="no-contact-section" x-ms-format-detection="none">We'll need a valid phone number and/or email address before you can log into your account.
            Please contact us at <b>1-800-347-2655</b> for immediate assistance.</div>
              <div className="no-contact-cancel" ><button class="changebtnproperty" onClick={this.handleCancel}>Cancel</button></div>
            </div>
          </div>
    </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lockedposts: state
  }
}

export default connect(mapStateToProps)(NoContactChannel);